import React, { useState, useEffect, useContext } from 'react';
import { MapContext } from 'react-map-gl';
const getMousePos = (event, container) => {
    const rect = container.getBoundingClientRect();
    return {
        x: event.clientX - rect.left - container.clientLeft,
        y: event.clientY - rect.top - container.clientTop,
    };
};
export const MarqueeSelect = ({ getSelectionBounds, setDragRotateStatus, }) => {
    const [startPoint, setStartPoint] = useState();
    const [currentPoint, setCurrentPoint] = useState();
    let staticStartPoint;
    let staticEndPoint;
    const { container } = useContext(MapContext);
    // If the map container is not available, do not continue
    if (!container) {
        return null;
    }
    useEffect(() => {
        const finishSelect = () => {
            getSelectionBounds({ start: staticStartPoint, end: staticEndPoint });
            // Clear all
            setStartPoint(undefined);
            setCurrentPoint(undefined);
            container.removeEventListener('mouseup', mouseUpEvent);
            container.removeEventListener('mousemove', mouseMoveEvent);
            if (setDragRotateStatus) {
                setDragRotateStatus(true);
            }
        };
        const mouseMoveEvent = (event) => {
            setCurrentPoint(getMousePos(event, container));
        };
        const mouseUpEvent = (event) => {
            staticEndPoint = getMousePos(event, container);
            finishSelect();
        };
        const mouseDownEvent = (event) => {
            if (!(event.shiftKey && event.button === 0)) {
                return;
            }
            if (setDragRotateStatus) {
                setDragRotateStatus(false);
            }
            container.addEventListener('mouseup', mouseUpEvent);
            container.addEventListener('mousemove', mouseMoveEvent);
            staticStartPoint = getMousePos(event, container);
            setStartPoint(getMousePos(event, container));
        };
        container.addEventListener('mousedown', mouseDownEvent, true);
        return () => {
            container.removeEventListener('mousedown', mouseDownEvent);
        };
    }, [container]);
    if (startPoint && currentPoint) {
        const minX = Math.min(startPoint.x, currentPoint.x);
        const minY = Math.min(startPoint.y, currentPoint.y);
        const maxX = Math.max(startPoint.x, currentPoint.x);
        const maxY = Math.max(startPoint.y, currentPoint.y);
        return (React.createElement("div", { className: "marquee-select__bounds-box", style: {
                position: 'absolute',
                left: `${minX}px`,
                top: `${minY}px`,
                width: `${maxX - minX}px`,
                height: `${maxY - minY}px`,
            } }));
    }
    return null;
};
//# sourceMappingURL=MarqueeSelect.js.map